import register from '@iez/core/start/init/register'
import AuthenticationPhoneNumber from '../../component/step-1/'
import AuthenticationOTP from '../../component/step-2/'

export default () => {
  register({
    pages: {
      AuthenticationPhoneNumber,
      AuthenticationOTP
    }
  })
}
